<div class="cancel-container">
  <div class="cancel-card">
    <div class="cancel-header">
      <svg xmlns="http://www.w3.org/2000/svg" class="cancel-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
      <h1 class="cancel-title">Pago Cancelado</h1>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-section">
      <div class="spinner"></div>
      <p class="loading-text">Procesando cancelación...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !isLoading" class="error-section">
      <div class="error-icon">❌</div>
      <p class="error-message">{{ error }}</p>
      <button *ngIf="eventSlug" (click)="goBackToEvent()" class="back-button">
        Volver al evento
      </button>
    </div>

    <!-- Success State -->
    <div *ngIf="success && !isLoading" class="success-section">
      <div class="success-icon">🚫</div>
      <h2 class="success-title">Cancelación Registrada</h2>
      <p class="success-description">
        Tu pago fue cancelado exitosamente. No se realizó ningún cobro.
        <br>
        Si deseas continuar con tu compra, puedes volver al evento y comenzar de nuevo.
      </p>
    </div>

    <div class="cancel-footer">
      <button *ngIf="eventSlug" (click)="goBackToEvent()" class="btn-event">
        Volver al Evento
      </button>
      <button (click)="goHome()" class="btn-home">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
        Volver al Inicio
      </button>
    </div>
  </div>
</div>
